import Point from "../../assets/v2/caroussel/point.png";
import CarousselSlide from "./CarousselSlide";
import React, {useEffect, useState} from "react";

// aside = cote à cote ( pas vraiment un Caroussel du coup )
export default function Caroussel({
                                      diapos,
                                      aside = false,
                                  }) {

    const speed = 3;    // En secondes
    const [step, setStep] = useState(0);

    useEffect(() => {
        const interval = setInterval(() => changeDiapo(), speed * 1000);
        return () => clearInterval(interval);
    }, [step]);


    const changeDiapo = () => {
        var localStep = step + 1;
        localStep = localStep % diapos.length;
        setStep(localStep)    // % diapos.length
    }

    if (aside) {
        return <div className="h-[319px] flex gap-2">
            {diapos.map((diapo, index) => {
                return <div className="h-full flex-grow"><CarousselSlide diapoData={diapo} key={index}/></div>
            })}
        </div>
    }

    return <div className="h-[319px]">
        <div className="flex justify-center">
            <CarousselSlide diapoData={diapos[step]} key={step}/>
        </div>
        <div className="flex justify-center gap-2 mt-[-25px]">
            {
                diapos.map((diapo, index) => {

                    if (index == step) {
                        return <img key={index} src={Point} className="opacity-100"/>
                    } else {
                        return <img key={index} src={Point} className="opacity-30"/>
                    }
                })
            }
        </div>
    </div>
}